import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { Clock } from "lucide-react";

export function DowntimeAnalysisWidget() {
  const data = [
    { reason: "Maintenance", minutes: 45, color: "var(--chart-4)" },
    { reason: "Material", minutes: 32, color: "var(--destructive)" },
    { reason: "Changeover", minutes: 28, color: "var(--chart-3)" },
    { reason: "Breakdown", minutes: 65, color: "var(--destructive)" },
    { reason: "Quality", minutes: 18, color: "var(--chart-1)" },
    { reason: "Other", minutes: 12, color: "var(--muted-foreground)" },
  ];

  const totalDowntime = data.reduce((sum, item) => sum + item.minutes, 0);

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <Clock className="h-4 w-4" />
            Downtime Analysis (Today)
          </CardTitle>
          <div className="text-right">
            <p className="text-xs text-muted-foreground">Total Downtime</p>
            <p className="text-lg font-bold">{totalDowntime} min</p>
          </div>
        </div>
      </CardHeader>
      <CardContent className="flex-1">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis type="number" fontSize={12} />
            <YAxis dataKey="reason" type="category" fontSize={12} width={80} />
            <Tooltip
              contentStyle={{
                backgroundColor: "var(--card)",
                border: "1px solid var(--border)",
                borderRadius: "8px",
              }}
            />
            <Bar dataKey="minutes" radius={[0, 4, 4, 0]}>
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
